import React from "react";
import dayjs from "dayjs";

import { channelType, sentimentCalc } from "lib/atsent";

import { threadResultsType } from "lib/store/dashboard";

import { FaceIcon } from "@atsent/components";

import { Label } from "components/atom/Label";
import { DashboardThreadDetail } from "components/atom/DashboardThreadDetail";

import "./ThreadItem.scss";

export type ThreadItemProps = {
  cx?: string;
  text: string;
  date: string;
  id: number;
  expend?: boolean;
  data: threadResultsType;
  currentState: [
    threadResultsType,
    React.Dispatch<React.SetStateAction<threadResultsType>>
  ];
  hasNumber?: boolean;
};

export const ThreadItem: React.FC<ThreadItemProps> = ({
  cx = "",
  text,
  date,
  id,
  data,
  hasNumber = false,
  expend = false,
  currentState,
}) => {
  const [currentData, setCurrentData] = currentState;
  return (
    <div
      className={`ThreadItem ${currentData.idx === id ? "active" : ""} ${cx}`}
      onClick={() => setCurrentData({ ...data })}
    >
      <div className={`wrapper ${hasNumber}`}>
        <div className="left">
          {hasNumber && <span className={"number"}>{id}</span>}
          <FaceIcon cx={sentimentCalc(data.result?.sentiment)} />
        </div>
        <div className={`contents-wrapper center`}>
          <div className="text">{text}</div>
          <span className="date">{dayjs(date).format("MMM DD. YYYY")}</span>
        </div>
        <div className="right">
          <div className={"blue-label"}>
            {!!data ? channelType(data?.type) : "분석 대기중"}
          </div>
          <Label cx={"small"}>
            {!!data.result ? data.result.aspect : "분석 대기중"}
          </Label>
        </div>
      </div>
      {expend && currentData.idx === id && (
        <DashboardThreadDetail data={currentData} />
      )}
    </div>
  );
};
